import { ToolName } from "@nova/constants"
import { createSelector, createSlice, isAnyOf } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"
import {
    clearEditingData,
    createNewMockedPerimeter,
    moveFirePerimeterToEditable,
} from "plugins/DrawPerimeter/FirePerimeterSlice"
import { setSnapshotOpen } from "plugins/PDFv2/PDFSlice"
import {
    createNewMockLine,
    clearEditingData as clearLineEditingData,
    moveLineToEditable,
} from "plugins/Toolbox/Line/LineSlice"
import {
    createNewMockRuler,
    clearEditingData as clearRulerEditingData,
    moveRulerToEditable,
} from "plugins/Toolbox/Ruler/slice"
import { setActiveTool } from "plugins/Toolbox/tool-registry"
import { startMaskDrawing, cancelMaskDrawing } from "plugins/Orthomosaic/OrthoMaskSlice"

const name = "shared-geometry-v1" as const

type UIState = {
    currentGeometryToolType?: ToolName | undefined
}

const initialState: UIState = {
    currentGeometryToolType: undefined,
}

const { reducer } = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(setActiveTool, (state, action) => {
                switch (action.payload) {
                    case ToolName.Line:
                    case ToolName.FirePerimeter:
                    case ToolName.Ruler:
                    case ToolName.OrthoMask:
                    case undefined:
                        state.currentGeometryToolType = action.payload
                        break
                    default:
                        state.currentGeometryToolType = undefined
                }
            })
            .addCase(setSnapshotOpen, (state, action) => {
                if (state.currentGeometryToolType && action.payload === true) {
                    state.currentGeometryToolType = undefined
                }
            })
            .addCase(startMaskDrawing, (state) => {
                state.currentGeometryToolType = ToolName.OrthoMask
            })
            .addMatcher(
                isAnyOf(
                    clearEditingData,
                    clearLineEditingData,
                    clearRulerEditingData,
                    cancelMaskDrawing
                ),
                (state) => {
                    state.currentGeometryToolType = undefined
                }
            )
            .addMatcher(isAnyOf(moveFirePerimeterToEditable, createNewMockedPerimeter), (state) => {
                state.currentGeometryToolType = ToolName.FirePerimeter
            })
            .addMatcher(isAnyOf(moveLineToEditable, createNewMockLine), (state) => {
                state.currentGeometryToolType = ToolName.Line
            })
            .addMatcher(isAnyOf(moveRulerToEditable, createNewMockRuler), (state) => {
                state.currentGeometryToolType = ToolName.Ruler
            }),
})

const root = (state: RootState) => state[name]

export const selectCurrentGeometryToolType = createSelector(
    root,
    (state) => state.currentGeometryToolType
)

export const uiReducer = { [name]: reducer }
